import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ycc-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {
  //page: number;
  pageLimit: number;
  currentPage: number;
  pagedResult: any[];
  tempData: any[];
  

  @Input() pagesToShow: number;

  @Input() perPage:number;
  @Input() data: any[];

  @Output() goPrev = new EventEmitter<boolean>();
  @Output() goNext = new EventEmitter<boolean>();
  @Output() goPage = new EventEmitter<any[]>();
  @Output() onAfterBind = new EventEmitter<any[]>();

  public get count(): number {
    if( this.data != undefined && this.data != null)
    return this.data.length;
  }

  constructor() { 
    this.pagedResult = [];
    this.currentPage = 1;
    this.pageLimit = 5;
  }

  public Bind(data:any[]){
    this.data = data;
    this.tempData = data;
    this.currentPage = 1;
    this.pagedResult = this.data.slice(0,this.perPage); 
    this.onAfterBind.emit(this.pagedResult);
   this.pageLimit = (this.totalPages() > 5) ? 5 : this.totalPages();
  }
 
  private rebindData():void {
    let startIndex = (this.currentPage- 1) * this.perPage;
    this.pagedResult = this.data.slice(startIndex,startIndex + this.perPage);
    //this.pagedResult = this.data.slice(16,18);
    this.goPage.emit(this.pagedResult);
  }

  totalPages(): number {
    return Math.ceil(this.count / this.perPage) || 0;
  }

  


  public getPages(): object[] {
    let array = [];
    if( this.data.length > 0 )
      {
        let count = this.pageLimit > this.totalPages() ? this.totalPages() : this.pageLimit;
        let startIndex = this.pageLimit > 5 ? this.pageLimit  - 4 : 1;
        for( let index = startIndex; index <= count ; index++ )
        {
            array.push(index);
        }
        return array;
      }
      return array;
    }
  
   
    public onPrevPages() {
      if( this.pageLimit > 10 )
      {
        this.pageLimit = this.pageLimit - 5;
        this.currentPage = this.pageLimit - 4;
      this.rebindData();
      }
    }
  
    public onNextPages() {
      if( this.pageLimit < this.totalPages() )
      {
        this.pageLimit = this.pageLimit + 5;
        this.currentPage = this.pageLimit - 4;
      this.rebindData();
      }
    }
  
    public onFirst(){
      this.pageLimit = 5;
      this.currentPage = 1;
    this.rebindData();
    }
  
    public onLast(){
      let reminder = this.totalPages() % 5 
      if( reminder === 0 )
        this.pageLimit = this.totalPages();
      else
        this.pageLimit = this.totalPages() + ( 5 - reminder );
        this.currentPage =this.totalPages();
       this.rebindData();
    }
  
  
    /**
     * Handles the pagination bar click
     * @param index {number}
     */
     public onPage(index:number){
      this.currentPage = index;
    this.rebindData();
    }
  
    /**
     * Handles the 'prev' angle button click on pagination bar
     * 
     */
    public onPrev(){
       this.currentPage = this.currentPage > 1 ?  this.currentPage - 1 : this.currentPage;
        if( this.currentPage  < this.pageLimit  &&  this.currentPage < this.pageLimit  - 4  )
        {
            if( this.pageLimit > 5 )
            {
              this.pageLimit = this.pageLimit - 5;
            }
        }
     this.rebindData();
    }
  
    /**
     * Handles the 'next' angle button click on pagination bar
     * 
     */
    public onNext(){
       this.currentPage = this.currentPage < this.totalPages() ?  this.currentPage + 1 : this.currentPage;
       if( this.currentPage  > this.pageLimit )
        {
          if( this.pageLimit < this.totalPages() )
          {
            this.pageLimit = this.pageLimit + 5;
          }
        }
     this.rebindData();
    }
}